import { useEffect, useState } from "react";

const Services = (props) => {
    const [value , setValue] = useState([])

    useEffect(()=>{
        if (props.pageType === "create") {
            const object = {...props.inputData}
            object[props.keyValue] = props.item.attributes.map((item)=>{
                return {
                    key:item.key,
                    label:item.label,
                    value:false,
                    id:item.id
                }
            })
            props.setInputData(object)
            setValue(object[props.keyValue])
        }else{
            setValue(props.editDataValue)
        }
    },[])

    function checkboxChangeHandler(targrt) {
        let array = [...value]
        const object = {...props.inputData}
        let index = array.findIndex((item)=> item.key === targrt.key)
        array[index].value = !array[index].value;
        object[props.keyValue] = array;
        props.setInputData(object)
        setValue(array)
    }
    return ( 
        <div className="col-span-full flex flex-wrap gap-5">
            {value.map((item)=>(
                <label className="flex items-center gap-1 min-w-[240px]">
                    <input type="checkbox" name={item.id} id={item.id} style={{appearance:"auto"}} onChange={()=>{checkboxChangeHandler(item)}} checked={item.value}/>
                    <span>{item.label}</span>
                </label>
            ))} 
        </div>
     );
}
 
export default Services;